import { render, staticRenderFns } from "./civilDetails.vue?vue&type=template&id=2d33d778&scoped=true"
import script from "./civilDetails.vue?vue&type=script&lang=js"
export * from "./civilDetails.vue?vue&type=script&lang=js"
import style0 from "./civilDetails.vue?vue&type=style&index=0&id=2d33d778&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33d778",
  null
  
)

export default component.exports